<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :label="$t('general.start_date')"
            :placeholder="$t('general.start_date')"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :label="$t('general.end_date')"
            :placeholder="$t('general.end_date')"/>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeIds"
              :options="officeDropdown"
              :is-clear="true"
              :is-multi="true"
              :label="$t('placeholder.office_name')"
              placeholder="Wählen Sie Bezeichnung aus"/>
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12 pt-4">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {defineEmits, defineProps, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  unemployedDropdown: {
    type: Array,
    require: true,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search, type) {
  emit('dropdown-fetch', search, type);
}

function onSelectValue(value, type) {
  if (!value) {
    emit('clear-dropdown', type);
  }
}

</script>

<style scoped>
</style>
